import Campaign from '@/services/campaign'
import { formatErrors } from '@utils/errors-alert'
import { bus } from '@/plugins/event-bus'

const fetch = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    Campaign.fetch().then((response) => {
      commit('SET_LIST', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const fetchAvailableAssignors = async ({ commit }, payerId) => {
  return new Promise((resolve, reject) => {
    Campaign.fetchAvailableAssignors(payerId).then((response) => {
      commit('SET_LIST_AVAILABLE', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const find = async (context, id) => {
  return new Promise((resolve, reject) => {
    Campaign.get(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const save = (context, payload) => {
  return new Promise(async (resolve, reject) => {
    const { verb, campaign } = payload
    const method = verb === 'put' ? 'update' : 'save'

    Campaign[method](campaign).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const sendMail = async (context, id) => {
  return new Promise((resolve, reject) => {
    Campaign.sendEmail(id).then((response) => {
      resolve(response.data)
    }).catch((error) => {
      bus.$emit('display-alert', {
        type: 'error',
        message: formatErrors(error.response.data)
      })
      reject(error)
    })
  })
}

const datasInvoices = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    Campaign.datasInvoices(payload).then((response) => {
      commit('SET_INFORMATION', response.data)
      resolve(response.data)
    }).catch((error) => {
      reject(error)
    })
  })
}

const resetStateInformation = ({ commit }) => {
  commit('RESET_INFORMATION')
}

export default {
  fetch,
  fetchAvailableAssignors,
  find,
  save,
  sendMail,
  datasInvoices,
  resetStateInformation
}



// WEBPACK FOOTER //
// ./src/features/campaigns/store/actions.js